import React from 'react';
 
class ABSDescriptionRow extends React.Component {
  render() { 
    return (
      <div style={{ height: 20 }} />
    );
  }
}
 
export default ABSDescriptionRow;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDescriptionRow/index.tsx